var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('side-bar-nav',[_c('template',{slot:"content"},[_c('profile-header'),(_vm.getProfileLoaded)?_c('router-view'):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }